angular.module('unica_event_tag.event_tag_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// EVENT TAG
		.state('app.event_tag', {
			url: '/event-tag',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/event-tag/templates/event-tag.html',
					controller: 'EventTagBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

			// EVENT TAG LIST
			.state('app.event_tag.list', {
				url: '/list/:event_id',
				views: {
					'eventTagContent': {
						templateUrl: './modules/event-tag/templates/list.html',
						controller: 'EventTagListController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'EventTag',
					parent: function($scope) {
						return 'app.event.detail({year: ' + $scope.year + ',id:' + $scope.event_id + '})';
					}
				}
			})

			// EVENT TAG CREATE
			.state('app.event_tag.create', {
				url: '/create/:event_id',
				views: {
					'eventTagContent': {
						templateUrl: './modules/event-tag/templates/create.html',
						controller: 'EventTagCreateController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Crea EventTag',
					parent: 'app.event_tag.list'
				}
			})

			// EVENT TAG EDIT
			.state('app.event_tag.edit', {
				url: '/edit/:event_id/:id',
				views: {
					'eventTagContent': {
						templateUrl: './modules/event-tag/templates/edit.html',
						controller: 'EventTagEditController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Modifica EventTag',
					parent: 'app.event_tag.list'
				}
			});


});

